var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFixDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m240 168h-96c-70.692 0-128 57.308-128 128v144c0 17.673 14.327 32 32 32h288c17.673 0 32-14.327 32-32v-144c0-70.692-57.308-128-128-128z",
    fill: "#5f78be"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m240 168h-48c17.673 0 32 14.327 32 32v240c0 17.673-14.327 32-32 32h144c17.673 0 32-14.327 32-32v-144c0-70.692-57.308-128-128-128z",
    fill: "#46508c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m240 168h-96c-8.837 0-16-7.163-16-16 0-8.837 7.163-16 16-16h96c8.837 0 16 7.163 16 16 0 8.837-7.163 16-16 16z",
    fill: "#faa019"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m240 136h-96c-26.51 0-48-21.49-48-48v-32c0-8.837 7.163-16 16-16h9.373c4.243 0 8.313 1.686 11.314 4.686l16 16c6.248 6.248 16.379 6.248 22.627 0l9.373-9.373c6.248-6.248 16.379-6.248 22.627 0l9.373 9.373c6.248 6.248 16.379 6.248 22.627 0l16-16c3.001-3.001 7.07-4.686 11.314-4.686h9.372c8.837 0 16 7.163 16 16v32c0 26.51-21.49 48-48 48z",
    fill: "#5f78be"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m272 40h-9.373c-4.243 0-8.313 1.686-11.313 4.686l-16 16c-6.249 6.249-16.379 6.248-22.628 0l-9.372-9.373c-3.124-3.124-7.219-4.686-11.314-4.686v57.373c0 17.673-14.327 32-32 32h80c26.51 0 48-21.49 48-48v-32c0-8.837-7.163-16-16-16z",
    fill: "#46508c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 328,
    fill: "#46508c",
    r: 96
  })), /*#__PURE__*/React.createElement("path", {
    d: "m216 320c4.418 0 8-3.582 8-8v-5.404c0-13.789-10.549-25.158-24-26.468v-8.128c0-4.418-3.582-8-8-8s-8 3.582-8 8v8.128c-13.451 1.31-24 12.679-24 26.468 0 11.466 7.309 21.605 18.186 25.231l22.568 7.522c4.334 1.445 7.246 5.485 7.246 10.053 0 5.843-4.753 10.596-10.596 10.596h-10.808c-5.843 0-10.596-4.753-10.596-10.596v-5.402c0-4.418-3.582-8-8-8s-8 3.582-8 8v5.404c0 13.789 10.549 25.158 24 26.468v8.128c0 4.418 3.582 8 8 8s8-3.582 8-8v-8.128c13.451-1.31 24-12.679 24-26.468 0-11.466-7.309-21.605-18.186-25.231l-22.568-7.522c-4.334-1.445-7.246-5.485-7.246-10.053 0-5.843 4.753-10.596 10.596-10.596h10.808c5.843 0 10.596 4.753 10.596 10.596v5.402c0 4.418 3.582 8 8 8z",
    fill: "#faa019"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m288 424h176c17.673 0 32-14.327 32-32v-128c0-17.673-14.327-32-32-32h-176c-17.673 0-32 14.327-32 32v128c0 17.673 14.327 32 32 32z",
    fill: "#f06423"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m288 424h128c17.673 0 32-14.327 32-32v-128c0-17.673-14.327-32-32-32h-128c-17.673 0-32 14.327-32 32v128c0 17.673 14.327 32 32 32z",
    fill: "#faa019"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 352,
    cy: 328,
    fill: "#f06423",
    r: 72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m464 232h-32v-24c0-30.878-25.122-56-56-56s-56 25.122-56 56v24h-32v-24c0-48.523 39.477-88 88-88s88 39.477 88 88z",
    fill: "#73cddc"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m400 320h-25.376c-2.414-6.807-7.816-12.209-14.624-14.624v-25.376c0-4.418-3.582-8-8-8s-8 3.582-8 8v25.376c-9.311 3.302-16 12.195-16 22.624 0 13.234 10.766 24 24 24 10.429 0 19.322-6.689 22.624-16h25.376c4.418 0 8-3.582 8-8s-3.582-8-8-8zm-56 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8-8-3.589-8-8z",
    fill: "#46508c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352,
    cy: 328,
    fill: "#faa51e",
    r: 8
  })), /*#__PURE__*/React.createElement("path", {
    d: "m422.343 78.343-32.686-32.687c-3.622-3.621-8.535-5.656-13.657-5.656s-10.035 2.035-13.657 5.657l-32.686 32.687c-1.061 1.061-1.657 2.5-1.657 4 0 3.124 2.533 5.657 5.657 5.657h26.343v64c0 8.836 7.164 16 16 16s16-7.164 16-16v-64.001h26.343c3.124 0 5.657-2.533 5.657-5.657 0-1.5-.596-2.939-1.657-4z",
    fill: "#f06423"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixDeposit);
export default __webpack_public_path__ + "static/media/fix-deposit.b394829e7951f9a321f04ee733fe208d.svg";
export { ForwardRef as ReactComponent };